import React from "react";
import Link from "gatsby-link";
import moment from "moment";
import GatsbyConfig from "../../../gatsby-config.js";
import { getPlanChangeData } from "../../utils/app-helpers";

import earlyBirdBlue from "../../../static/images/early-bird-blue.png";
import earlyBirdGreen from "../../../static/images/early-bird-green.png";
import hourglass from "../../../static/images/hourglass.png";
import superEarlyBird from "../../../static/images/superearlybird.png";
import sunburst from "../../../static/images/sunburst.png";
import pineapple from "../../../static/images/pineapple.png";
import preSale from "../../../static/images/pre-sale-icon.png";
import anniversarySale from "../../../static/images/anniversary-icon.png";
import shortSale from "../../../static/images/timer-icon.png";

const dataMap = {
  earlybirdblue: { image: earlyBirdBlue, message: "Early Bird Special" },
  earlybird2blue: { image: earlyBirdBlue, message: "Early Bird 2.0" },
  earlybirdgreen: { image: earlyBirdGreen, message: "Early Bird Special" },
  superearlybird: { image: superEarlyBird, message: "Super Early Bird" },
  lastchance: { image: hourglass, message: "Last Chance Sale" },
  alohasale: { image: pineapple, message: "Aloha Sale" },
  summersale: { image: sunburst, message: "Summer Sale" },
  presale: { image: preSale, message: "Pre-Sale" },
  anniversary: { image: anniversarySale, message: "Anniversary Sale" },
  shortsale: { image: shortSale, message: "Limited Time to Book" },
};

const { siteMetadata: config } = GatsbyConfig;

export default class PromoBanner extends React.Component {
  render() {
    const { trip, kind } = this.props;

    if (!kind || !(kind in dataMap)) return null;

    const { image, message } = dataMap[kind];
    const tripData = config.trips[trip];
    let cutoff = tripData.saleEndsAt;

    if (!cutoff) {
      const cutoffDate = moment(
        tripData.useMaxSubMonthsCutoff,
        "MM-DD-YYYY"
      ).subtract(1, "day");

      if (cutoffDate.diff(new Date())) {
        const { planChangeDay } = getPlanChangeData(tripData, { moment });

        cutoff = moment(planChangeDay, "MM-DD-YYYY").format("MMMM D");
      } else {
        cutoff = cutoffDate.format("MMMM D");
      }
    }
    return (
      <Link
        className={`banner promo-banner ${kind}-banner`}
        to={`/${trip}/prices/`}
      >
        <span className="wrap">
          <span className="icon">
            <img src={image} alt="" />
          </span>
          <span className="message">
            {message} <time>Ends {cutoff}</time>
          </span>
        </span>
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/promo-banner.js